<button mat-button (click)="changeLang()">
  {{ currentLang$$ | async | uppercase }}
</button>
